export default "__VITE_ASSET__f415e943__"